import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SkeletonCard = () => (
  <div className="animate-pulse bg-gray-200 rounded-md h-[300px] md:h-[450px]">
    <div className="w-full h-full bg-gray-300 rounded-md"></div>
  </div>
);
const CoachingPrograms = () => {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  const allprograms = () => {
    let data = "";

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/sports-categories/all-categories`,
      headers: {},
      data: data,
    };
    setLoading(true);
    axios
      .request(config)
      .then((response) => {
        // console.log(response.data);
        const categories = response?.data?.categories || [];
        const excludeList = ["special attraction"];
        const filtered = categories.filter(
          (cat) => !excludeList.includes(cat.name?.toLowerCase())
        );
        setPrograms(filtered);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    allprograms();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // animate only once
      offset: 100, // trigger offset
    });
  }, []);

  return (
    <section className="px-4 md:px-8 lg:px-12 mb-12">
      {/* Heading */}
      <h2
        className="font-heading text-xl md:text-3xl font-bold text-start my-10 md:my-12 "
        data-aos={
          typeof window !== "undefined" && window.innerWidth >= 768
            ? "fade-up"
            : ""
        }
      >
        ACADEMY COACHING PROGRAMS
      </h2>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-6 my-10 sm:my-12 md:my-16 lg:my-16 md:pb-4">
        {loading
          ? Array.from({ length: 5 }).map((_, idx) => (
              <div
                key={idx}
                className={`relative ${
                  idx % 2 === 0 ? "md:mb-12" : "md:mt-12"
                }`}
              >
                <SkeletonCard />
              </div>
            ))
          : programs.map((program, idx) => (
              <div
                onClick={() => {
                  navigate(`/sports-academy`, {
                    state: {
                      activeTab: program?._id,
                    },
                  });
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                key={idx}
                className={`relative group h-[300px] md:h-[420px] lg:h-[500px] cursor-pointer rounded-md overflow-hidden shadow-lg
                    ${
                      idx % 2 === 0 ? "md:-translate-y-6" : "md:translate-y-6"
                    }`}
              >
                {/* Background Image */}
                <div
                  style={{ backgroundImage: `url(${program?.homeImageUrl})` }}
                  className="absolute inset-0 bg-center bg-cover group-hover:scale-105 transition duration-300"
                ></div>

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/60 transition duration-300"></div>

                {/* Title */}
                <div className="h-full relative z-[200] flex items-end justify-center">
                  <span
                    style={{
                      transformOrigin: "left",
                      transform: "rotate(-90deg)",
                    }}
                    className="m-auto absolute bottom-0 left-1/2 -translate-x-1/2 whitespace-nowrap text-white font-semibold text-3xl md:text-4xl  tracking-wider opacity-0 group-hover:opacity-100 transition duration-300 uppercase"
                  >
                    {program.name}
                  </span>
                </div>
              </div>
            ))}
      </div>
    </section>
  );
};

export default CoachingPrograms;